import { useMutation } from '@tanstack/react-query';
import { useState } from 'react';
import { PasswordChangeSchema } from '@greenostrov/shared';
import { useAuth } from '../auth/AuthContext';
import { api } from '../lib/api';

export function AccountPage() {
  const { admin, refreshMe } = useAuth();
  const [currentPassword, setCurrent] = useState('');
  const [newPassword, setNew] = useState('');
  const [message, setMessage] = useState<string | null>(null);

  const mutation = useMutation({
    mutationFn: (payload: { currentPassword: string; newPassword: string }) =>
      api.changePassword(payload),
    onSuccess: () => {
      setMessage('Пароль изменён');
      setCurrent('');
      setNew('');
      void refreshMe();
    },
  });

  function submit(e: React.FormEvent) {
    e.preventDefault();
    setMessage(null);
    const parsed = PasswordChangeSchema.safeParse({ currentPassword, newPassword });
    if (!parsed.success) {
      setMessage(parsed.error.issues[0]?.message ?? 'Проверьте поля');
      return;
    }
    mutation.mutate(parsed.data);
  }

  return (
    <div>
      <h1 style={{ fontSize: 24, marginBottom: 4 }}>Аккаунт</h1>
      <p style={{ color: 'var(--text-muted)', marginBottom: 24 }}>
        {admin?.name} · {admin?.username}
        {admin?.mustChangePassword && (
          <span style={{ marginLeft: 12, color: 'var(--warning)', fontWeight: 600 }}>
            требуется смена пароля
          </span>
        )}
      </p>

      <form onSubmit={submit} className="card" style={{ padding: 24, maxWidth: 480, display: 'grid', gap: 14 }}>
        <h2 style={{ fontSize: 18 }}>Смена пароля</h2>
        <label>
          <div style={{ fontSize: 12, color: 'var(--text-muted)', marginBottom: 4, fontWeight: 600 }}>
            Текущий пароль
          </div>
          <input
            className="input"
            type="password"
            autoComplete="current-password"
            value={currentPassword}
            onChange={(e) => setCurrent(e.target.value)}
          />
        </label>
        <label>
          <div style={{ fontSize: 12, color: 'var(--text-muted)', marginBottom: 4, fontWeight: 600 }}>
            Новый пароль (минимум 12 символов, буква + цифра)
          </div>
          <input
            className="input"
            type="password"
            autoComplete="new-password"
            value={newPassword}
            onChange={(e) => setNew(e.target.value)}
          />
        </label>

        {message && (
          <div
            style={{
              padding: '10px 14px',
              borderRadius: 8,
              background: mutation.isError ? 'var(--danger-soft)' : 'var(--success-soft)',
              color: mutation.isError ? 'var(--danger)' : 'var(--success)',
            }}
          >
            {message}
          </div>
        )}

        <button type="submit" className="btn btn-primary" disabled={mutation.isPending}>
          {mutation.isPending ? 'Сохраняем…' : 'Сменить пароль'}
        </button>
      </form>
    </div>
  );
}
